export type SmsTemplateKey =
  | 'sms_template_order_confirmed_customer'
  | 'sms_template_new_order_admin'
  | 'sms_template_rider_assigned_rider'
  | 'sms_template_rider_assigned_customer';

export type MessageTemplateKey = SmsTemplateKey | 'whatsapp_order_message_template';

export interface SmsTemplateDefinition {
  key: SmsTemplateKey;
  label: string;
  description: string;
  defaultValue: string;
}

export const WHATSAPP_ORDER_MESSAGE_DEFAULT =
  'Hello Karebe, I just created order {{order_reference}} for {{items_summary}}{{amount_summary}}. Please confirm the next step.';

export const SMS_ENABLED_SETTING_KEY = 'sms_enabled';
export const SMS_PROVIDER_USERNAME_SETTING_KEY = 'sms_provider_username';
export const SMS_PROVIDER_API_KEY_SETTING_KEY = 'sms_provider_api_key';
export const SMS_PROVIDER_SENDER_ID_SETTING_KEY = 'sms_provider_sender_id';
export const SMS_TEST_PHONE_SETTING_KEY = 'sms_test_phone';

export const SMS_TEMPLATE_DEFINITIONS: SmsTemplateDefinition[] = [
  {
    key: 'sms_template_order_confirmed_customer',
    label: 'Order Confirmed: Customer',
    description: 'Sent when a manager confirms the order.',
    defaultValue:
      'Hi {{customer_name}}, your order {{order_reference}} has been confirmed. We are preparing it now.',
  },
  {
    key: 'sms_template_new_order_admin',
    label: 'New Order Alert: Admin',
    description: 'Sent when a new order is started in the system.',
    defaultValue:
      'New order {{order_reference}} has been started for {{customer_name}} ({{customer_phone}}).',
  },
  {
    key: 'sms_template_rider_assigned_rider',
    label: 'Rider Assigned: Rider',
    description: 'Sent when a rider is assigned a delivery.',
    defaultValue:
      'Hi {{rider_name}}, you have a new delivery for order {{order_reference}} to {{delivery_address}}.',
  },
  {
    key: 'sms_template_rider_assigned_customer',
    label: 'Rider Assigned: Customer',
    description: 'Sent when a rider is assigned and the order is heading out.',
    defaultValue:
      'Hi {{customer_name}}, rider {{rider_name}} has been assigned to order {{order_reference}}. Your order is on the way soon.',
  },
];

export const SMS_TEMPLATE_PLACEHOLDERS = [
  '{{customer_name}}',
  '{{customer_phone}}',
  '{{order_id}}',
  '{{order_number}}',
  '{{order_reference}}',
  '{{rider_name}}',
  '{{delivery_address}}',
  '{{branch_id}}',
];

export const WHATSAPP_ORDER_MESSAGE_PLACEHOLDERS = [
  '{{order_reference}}',
  '{{items_summary}}',
  '{{amount_summary}}',
  '{{customer_name}}',
];

export type SmsTemplateContext = Record<string, string | number | null | undefined>;

export function renderSmsTemplate(template: string, context: SmsTemplateContext): string {
  return template.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_match, token: string) => {
    const value = context[token];
    return value === null || value === undefined ? '' : String(value);
  }).replace(/\s{2,}/g, ' ').trim();
}

export function buildSmsEventKey(
  eventType: string,
  orderId: string,
  recipientType: string,
  recipientId?: string | null
): string {
  return [eventType, orderId, recipientType, recipientId || 'default'].join(':');
}
